export const env = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV
  : "prod";

const siteUrls = {
  local: process.env.REACT_APP_API_URL_LOCAL,
  dev: process.env.REACT_APP_API_URL_DEV,
  prod: process.env.REACT_APP_API_URL_PROD,
};

export const API_URL = siteUrls[env];
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const REACT_APP_GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

export const webSiteUrl =
  env === "dev"
    ? "https://staging.spacii.ai"
    : env === "prod"
      ? "https://www.spacii.ai"
      : "http://localhost:3000";
// export const webSiteUrl = "http://localhost:3000";
